import {PRIMARY_NAV_ALIGNMENT_TYPES} from "../../config/constants"

export type ContainerProps = {
    alignment: string
    loaded: boolean
}
export type FlexStyle = "left" | "center" | "right" | "space-between"
type SnailAlignment = PRIMARY_NAV_ALIGNMENT_TYPES

export const calculateAlignment = (alignment: SnailAlignment): FlexStyle => {
    switch (alignment) {
        case PRIMARY_NAV_ALIGNMENT_TYPES.EVENLY_SPREAD:
            return "space-between"
        case PRIMARY_NAV_ALIGNMENT_TYPES.CENTER_ALIGNED:
            return "center"
        case PRIMARY_NAV_ALIGNMENT_TYPES.LEFT_ALIGNED:
            return "left"
        case PRIMARY_NAV_ALIGNMENT_TYPES.RIGHT_ALIGNED:
            return "right"
        default:
            return "space-between"
    }
}
